import * as React from 'react'
import 'react-datepicker/dist/react-datepicker-cssmodules.css'
import 'react-datepicker/dist/react-datepicker.css'
import * as ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Route, Router, Switch } from 'react-router-dom'
import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunkMiddleware from 'redux-thunk'
import history from './history'
import registerServiceWorker from './registerServiceWorker'
import rootReducer from './state/reducers'
import './styles/css/index.css'
import App from './containers/App'
import { NotificationComponent } from './components/ui/notification-provider'
import { DriverManifestsProvider } from './components/driver-manifests/DriverManifestsContext'

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunkMiddleware)))

const Root = () => (
  <NotificationComponent>
    <DriverManifestsProvider>
      <Provider store={store}>
        <Router history={history}>
          <Switch>
            <Route path='/' component={App} />
          </Switch>
        </Router>
      </Provider>
    </DriverManifestsProvider>
  </NotificationComponent>
)

ReactDOM.render(<Root />, document.getElementById('root') as HTMLElement)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.tsx